module.exports = __webpack_public_path__ + "img/award_patuakkhali_16x9.f6e4912f.png";